// extracted by css-extract-rspack-plugin
export default {"iframe_container":"iframe_container___EYjcr","iframeFaq":"iframeFaq___oaN0P"};